export enum EHostType {
    Findd,
    OnShift
}